<template>
  <EntityAudit :entity-type="entityName" />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { EntityAudit } from "@modernary/mui/components/audit";
import { entityAuditApi } from "@/services/endpoints";

export default defineComponent({
  name: "EntityAudits",
  components: {
    EntityAudit,
  },
  props: {
    entityName: {
      type: String,
      required: true,
    },
  },
  setup(props, context) {
    return {
      entityAuditApi,
    };
  },
});
</script>
